import { CATEGORY_LEVEL_2 } from '../utils/categoryHelpers';
import { ATTRIBUTE_ITEMTYPE } from './attributesConstants';

export const tradeDoublePointsPromo = {
    END_DATE: '2018-10-31T23:59:59Z',
    TARGET_CATEGORY: {
        LEVEL: CATEGORY_LEVEL_2,
        NAME: 'lighting',
    },
    TARGET_FILTER: {
        NAME: ATTRIBUTE_ITEMTYPE,
        ATTRIBUTE: 'new-custom',
    },
};
